import { Module } from '@nestjs/common';
import { ProposalsService } from './proposals.service';
import { ProposalsController } from './proposals.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ProposalAttachmentsEntity, ProposalItemsEntity, ProposalPricingSummaryEntity, ProposalsEntity, UsersEntity } from '@crm/dto';
import { GuardsModule } from '../guards/guards.module';
import { SupabaseModule } from '../supabase/supabase.module';

@Module({
  controllers: [ProposalsController],
  providers: [ProposalsService],
  imports: [
    TypeOrmModule.forFeature([
      ProposalsEntity,
      ProposalAttachmentsEntity,
      ProposalItemsEntity,
      ProposalPricingSummaryEntity,
      UsersEntity,
    ]),
    GuardsModule,
    SupabaseModule
  ],
})
export class ProposalsModule {}
